import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RetailersDBContext } from 'contexts/RetailersDBContext';
import * as favoriteRetailersSelectors from 'store/favoriteRetailers/selectors';
import useAction from 'hooks/useAction';
import * as favoriteRetailersActions from 'store/favoriteRetailers/actions';
import { addNewRecentSearch } from 'store/globalSearch/actions';

/**
 * Return retailers from indexedDB base on the global query
 *
 * @returns {undefined|Array} undefined in case if favoriteRetailers is initializing or retailer DB not configured, Array of retailers is case if initialization is finished
 */
const useGlobalSearchRetailers = query => {
  const [retailers, setRetailers] = useState(undefined);
  const retailersDB = useContext(RetailersDBContext);

  const favoriteRetailersIsLoaded = useSelector(favoriteRetailersSelectors.getIsLoaded);
  const requestFetchFavoriteRetailers = useAction(favoriteRetailersActions.requestFetchFavoriteRetailers);
  const addNewRecentSearchFunc = useAction(addNewRecentSearch);

  useEffect(() => {
    if (!favoriteRetailersIsLoaded) {
      requestFetchFavoriteRetailers();
    }
  }, [favoriteRetailersIsLoaded]);

  useEffect(() => {
    const updateGlobalSearchRetailers = async () => {
      if (retailersDB.isConfigured && favoriteRetailersIsLoaded) {
        const _retailers = (await retailersDB.getRetailersOrderedByDistanceToQuery(query)) || [];

        if (_retailers?.length) {
          addNewRecentSearchFunc(query);
        }

        setRetailers(_retailers);
      }
    };

    updateGlobalSearchRetailers();
  }, [query, favoriteRetailersIsLoaded, retailersDB]);

  return { retailers, isLoaded: retailers !== undefined && retailersDB.isConfigured };
};

export default useGlobalSearchRetailers;
